import { render } from "./RecycleDepartment.vue?vue&type=template&id=1a1a6ca0"
import script from "./RecycleDepartment.vue?vue&type=script&lang=js"
export * from "./RecycleDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__